import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

export const getBooks = () => client.get("/bible/books").then((r) => r.data);
export const getChapter = (book, chapter, translation = "WEB") =>
  client.get(`/bible/chapter/${book}/${chapter}`, { params: { translation } }).then((r) => r.data);
export const searchBible = (q, translation = "WEB") =>
  client.get(`/bible/search`, { params: { q, translation } }).then((r) => r.data);
export const getDaily = () => client.get(`/bible/daily`).then((r) => r.data);
export const getTranslations = () => client.get(`/bible/translations`).then((r) => r.data.translations);
export const getRecap = (book, chapter) =>
  client.get(`/recap/${book}/${chapter}`, { timeout: 70000 }).then((r) => r.data);

// Reading Memory Score quiz (archived once per chapter, served free)
export const getQuiz = (book, chapter) =>
  client.get(`/quiz/${book}/${chapter}`, { timeout: 70000 }).then((r) => r.data);

// AI study notes (archived once per chapter, served free)
export const getStudy = (book, chapter) =>
  client.get(`/study/${book}/${chapter}`, { timeout: 70000 }).then((r) => r.data);

// "Explain Like I'm 15" — 4 reading levels per chapter (archived once)
export const getExplain = (book, chapter, level) =>
  client.get(`/explain/${book}/${chapter}`, { params: level ? { level } : {}, timeout: 70000 }).then((r) => r.data);

export const getVerseExplain = (book, chapter, verse) =>
  client.get(`/explain/${book}/${chapter}/${verse}`, { timeout: 70000 }).then((r) => r.data);

// Bible Character Cards (curated list + per-character card, archived once)
export const getCharacters = () =>
  client.get(`/characters`).then((r) => r.data.characters);
export const getCharacterCard = (cid) =>
  client.get(`/characters/${cid}`, { timeout: 70000 }).then((r) => r.data);
export const characterImageUrl = (cid) => `${API}/characters/${cid}/image`;

// Word Study
export const getWordStudyPopular = () =>
  client.get(`/word-study/popular`).then((r) => r.data.words);
export const getWordStudy = (word) =>
  client.get(`/word-study/${encodeURIComponent(word)}`, { timeout: 70000 }).then((r) => r.data);


// Devotionals
export const getDevotionalTopics = () =>
  client.get(`/devotional/topics`).then((r) => r.data.topics);
export const getDevotional = (topic, day) =>
  client.get(`/devotional`, { params: { topic, day }, timeout: 70000 }).then((r) => r.data);

export const getVOTD = (date) =>
  client.get(`/votd`, { params: { date } }).then((r) => r.data);
export const votdImageUrl = (slug) => `${API}/votd/image/${slug}`;

// Onyx audio narration (generated once & cached). Available for WEB & KJV.
export const AUDIO_TRANSLATIONS = ["WEB", "KJV", "ASV"];
// Freemium: these translations are always free; NKJV requires a subscription.
export const FREE_TRANSLATIONS = ["KJV", "WEB", "ASV", "NLT"];
export const PREMIUM_TRANSLATIONS = ["NKJV"];
export const chapterAudioUrl = (book, chapter, translation = "WEB") =>
  `${API}/audio/chapter/${book}/${chapter}?translation=${translation}`;

// Reading Atmosphere (ambient + nature loops)
export const getAtmosphereManifest = () =>
  client.get(`/atmosphere/manifest`).then((r) => r.data.tracks);
export const atmosphereTrackUrl = (id) => `${API}/atmosphere/track/${id}`;

// Family sharing
export const familyCreate = (name, display_name, device_id) =>
  client.post(`/family/create`, { name, display_name, device_id }).then((r) => r.data);
export const familyJoin = (code, display_name, device_id) =>
  client.post(`/family/join`, { code, display_name, device_id }).then((r) => r.data);
export const familyGet = (code) => client.get(`/family/${code}`).then((r) => r.data);
export const familyAddPrayer = (code, device_id, name, text) =>
  client.post(`/family/${code}/prayer`, { device_id, name, text }).then((r) => r.data);
export const familyPray = (code, pid, device_id) =>
  client.post(`/family/${code}/prayer/${pid}/pray`, null, { params: { device_id } }).then((r) => r.data);
export const familyAnswer = (code, pid) =>
  client.post(`/family/${code}/prayer/${pid}/answer`).then((r) => r.data);
